export class SetObjectState {
  static readonly type = '[ProductLineConfig] Set Object State';
  constructor(public entities: any) {}
}

export class ResetState {
  static readonly type = '[ProductLineConfig] Reset State';
  constructor() {}
}


